import { Component } from '@angular/core';
import { TermsAcceptanceStorage } from './terms-acceptance-storage';
import { TermsStorage } from './terms-storage';
import { UrlBuilder } from '../core/url-builder/url-builder';

@Component({
    selector: 'accept-terms-page',
    template: require('./accept-terms-page.component.html'),
    styles: [require('./accept-terms-page.component.scss')]
})
export class AcceptTermsPageComponent {

    public userAcceptsTerms = false;

    public disclaimer: Promise<string>;

    constructor(
        private termsAcceptanceStorage: TermsAcceptanceStorage,
        private urlBuilder: UrlBuilder,
        termsStorage: TermsStorage) {
        this.disclaimer = termsStorage.disclaimerHtml;
    }

    public async onSubmit() {
        await this.termsAcceptanceStorage.acceptTerms();
        this.urlBuilder.esa().navigateToReturnUrl();
    }

    public onCancel() {
        this.urlBuilder.esa().logout().navigate({ saveReturnUrl: true });
    }
}